import React from "react";
import FlatButton from "material-ui/FlatButton";
import IconBack from "material-ui/svg-icons/navigation/chevron-left";
import colors from "../../styles/colors";
import "../../resources/styles/main.css";

const style = {
  container: {
    display: "flex",
    flexDirection: "row",
  },
  title: {
    textAlign: "center",
    fontSize: 32,
  },
  titleText1: {
    display: "inline-block",
    color: colors.primary,
  },
  titleText2: {
    display: "inline-block",
  },
  backButtonLabel: {
    fontSize: 20,
    fontWeight: "bold",
    color: colors.primary,
  },
};

export default ({
  text1,
  text2,
  goBack,
  whiteLabelSettings = null,
  showIframe = false,
  closeIframe,
}) => {
  return (
    <div className={"title"}>
      {goBack && !showIframe && (
        <FlatButton
          style={style.backButtonPos}
          labelStyle={
            (style.backButtonLabel,
            {
              color:
                whiteLabelSettings && whiteLabelSettings.isWhiteLabel
                  ? whiteLabelSettings.accentColor
                  : "",
            })
          }
          label="Back"
          icon={
            <IconBack
              color={
                whiteLabelSettings && whiteLabelSettings.isWhiteLabel
                  ? whiteLabelSettings.accentColor
                  : colors.primary
              }
            />
          }
          onClick={() => goBack()}
        />
      )}
      {showIframe && (
        <FlatButton
          style={style.backButtonPos}
          labelStyle={
            (style.backButtonLabel,
            {
              color:
                whiteLabelSettings && whiteLabelSettings.isWhiteLabel
                  ? whiteLabelSettings.accentColor
                  : "",
            })
          }
          label="Close Physiotec/Wibbi"
          icon={
            <IconBack
              color={
                whiteLabelSettings && whiteLabelSettings.isWhiteLabel
                  ? whiteLabelSettings.accentColor
                  : colors.primary
              }
            />
          }
          onClick={() => closeIframe()}
        />
      )}
      <div style={style.title}>
        <span
          style={
            (style.titleText1,
            {
              color:
                whiteLabelSettings && whiteLabelSettings.isWhiteLabel
                  ? whiteLabelSettings.accentColor
                  : "",
            })
          }
        >
          {text1}
        </span>{" "}
        <span style={style.titleText2}>{text2}</span>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/Title.js